import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { useDispatch } from 'react-redux';
import { analyticsActions } from '../../redux/analytics/actions/AnalyticsActions.creators';
import { basketActions } from '../../redux/basket/actions/BasketActions.creators';
import { useProductListerContext } from './context';
import { FiltersEmptyResult } from './empty-result/FiltersEmptyResult';
import { InStoreFilterEmptyResult } from './empty-result/InStoreFilterEmptyResult';
import { ListerEmptyResult } from './empty-result/ListerEmptyResult';
import { getFlattenedActiveFilters } from './filters/filters-active/filtersActive.utils';
export const ProductListerEmptyResults = () => {
    const { pageInfo, mainWebShop, feature_toggles } = useAemConfig();
    const { inStoreFilter, updateStoreId, removeAllFilters, urlState: { storeId }, filterState: { activeFilters }, parentPage, query: { data: { itemCount } = {}, isFetching }, } = useProductListerContext();
    const flattenedActiveFilters = getFlattenedActiveFilters(activeFilters);
    const dispatch = useDispatch();
    const noResults = itemCount === 0;
    const hasActiveFilters = Boolean(flattenedActiveFilters.length);
    const openInStoreFilterPopup = () => {
        dispatch(basketActions.createCCPopupOpenAction());
        dispatch(analyticsActions.storeFilterModified());
    };
    if (feature_toggles.lister_in_store_filter && noResults && !isFetching && storeId) {
        return (_jsx(InStoreFilterEmptyResult, { activeStoreId: storeId, inStoreFilter: inStoreFilter, handleOpenPopup: openInStoreFilterPopup, removeAllActiveFilters: removeAllFilters, updateStoreId: updateStoreId }));
    }
    if (noResults && !isFetching && hasActiveFilters) {
        return _jsx(FiltersEmptyResult, { removeAllActiveFilters: removeAllFilters, mainWebShop: mainWebShop });
    }
    return (pageInfo.isCategoryPage || pageInfo.isBrandAsCategoryPage) &&
        noResults &&
        !isFetching &&
        !hasActiveFilters ? (_jsx(ListerEmptyResult, { parentPageHref: parentPage === null || parentPage === void 0 ? void 0 : parentPage.href, parentPageTitle: parentPage === null || parentPage === void 0 ? void 0 : parentPage.title, mainWebShop: mainWebShop })) : null;
};
